import React from 'react';
import { Section } from './Shared';
const costs: [string, string][] = [['Sin recetarios claros', 'Fórmulas que fallan = productos rechazados'], ['Sin cálculo de costos', 'Perdés dinero sin saberlo'], ['Sin branding profesional', 'No te compran por cómo se ve'], ['Sin estrategia de venta', 'Esperás a que te encuentren'], ['Sin consistencia en producción', 'Cada lote sale diferente'], ['Sin monetización de redes', 'Miles de seguidores, cero ventas']];
export function CostComparison() {
  return <Section data-id="element-17" data-mp="2ujx5evqee9qf">
      <div className="mb-10 text-center" data-id="element-18" data-mp="2ulhysi0z7mmp">
        <h2 className="flex justify-center font-serif text-2xl font-bold text-brand-taupe md:text-4xl" data-id="element-19" data-mp="2uic7cw4vk8nt">
          <span className="mr-3" data-id="element-20" data-mp="2pn6oy7aolc4h">⚖️</span>¿CUÁNTO CUESTA NO TENERLO?
        </h2>
      </div>
      <div className="mx-auto max-w-4xl" data-id="element-21" data-mp="2kodaocnklh39">
        <div className="mb-4 hidden grid-cols-2 gap-4 px-4 font-serif text-lg font-bold md:grid" data-id="element-22" data-mp="1e6q6e53tyfde">
          <span className="text-brand-taupe" data-id="element-23" data-mp="196kk74gbxl2p">Sin la Guía Definitiva</span>
          <span className="text-brand-goldDark" data-id="element-24" data-mp="2lassn6ag814k">Consecuencia real</span>
        </div>
        <div className="space-y-3" data-id="element-25" data-mp="2l8oii6lyi5vu">
          {costs.map(([without, result]) => <div key={without} className="paper-panel grid gap-2 rounded-xl p-4 md:grid-cols-2 md:gap-4 md:p-5" data-id="element-26" data-mp="2pbuiiwih70tv">
              <p className="text-sm font-semibold text-brand-text" data-id="element-27" data-mp="2bcd2b5j8wvw4">{without}</p>
              <p className="text-sm font-medium text-brand-sageMid" data-id="element-28" data-mp="2gaeh3e9n291s">
                <span className="mr-2 text-brand-goldDark md:hidden" data-id="element-29" data-mp="21m9y096obvih">→</span>
                {result}
              </p>
            </div>)}
        </div>
      </div>
      <div className="mx-auto mt-12 max-w-3xl rounded-2xl border border-brand-sage/40 bg-brand-sageMist/70 p-8 text-center" data-id="element-30" data-mp="26fmj49c59k6h">
        <p className="font-display text-xl font-semibold italic leading-relaxed text-brand-sageMid md:text-2xl" data-id="element-31" data-mp="1xkygkqxyegld">
          “La emprendedora que tiene un sistema fabrica con confianza. La que fabrica con confianza presenta mejor. La
          que presenta mejor cobra premium.”
        </p>
        <p className="mt-4 text-lg" data-id="element-32" data-mp="14if8zb0jkog2">🌿</p>
      </div>
    </Section>;
}